import { Loan } from '@nemuru-eng/js-api-client';

import { ConditionalWrapper } from '@/components/shared/components/ConditionalWrapper';
import { ConditionsSummaryWrapper } from '@/components/shared/components/ConditionsSummary/_shared/ConditionsSummaryWrapper';
import { LoanConditionsDataDisplay } from '@/components/shared/components/ConditionsSummary/LoanConditionsSummary/components/LoanConditions/LoanConditionsDataDisplay';
import { getCardHeaderParamsByApplicationType } from '@/components/shared/components/ConditionsSummary/LoanConditionsSummary/config';
import { ApplicationType } from '@/config/types';

export const LoanConditionsSummary = ({
  loan,
  applicationType,
  showHeader = true,
}: {
  loan: Loan;
  applicationType: ApplicationType;
  showHeader?: boolean;
}) => {
  const CustomCardHeaderParams = getCardHeaderParamsByApplicationType(applicationType);
  return (
    <ConditionalWrapper
      condition={showHeader}
      wrapper={(children) => (
        <ConditionsSummaryWrapper
          title={CustomCardHeaderParams.title}
          surtitle={CustomCardHeaderParams.surtitle}
          iconName={CustomCardHeaderParams.iconName}
          id={loan.id}
          applicationType={applicationType}
          principal={applicationType === ApplicationType.CARD ? undefined : loan.assetDetails.totalBudget}
        >
          {children}
        </ConditionsSummaryWrapper>
      )}
      children={<LoanConditionsDataDisplay loan={loan} />}
    />
  );
};
